import React from "react";
import {Instagram, Phone, MessageCircle, Mail, MapPin, Facebook, Twitter} from "lucide-react";
import logo from '../../Assets/Images/logo-black.webp'

const Footer = () => {
    // Colores inspirados en la bandera argentina
    const argentinaBlue = "rgb(108, 172, 228)";

    return (
        <footer className="w-full bg-gradient-to-b from-blue-50 to-white border-t border-gray-200">
            <div className="max-w-7xl mx-auto px-4 py-8">
                {/* Grid principal */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    {/* Columna 1 - About */}
                    <div className="space-y-4">
                        <h3 className="text-xl font-bold text-blue-900">About Us</h3>
                        <p className="text-gray-600">
                            Delivering innovative business setup solutions in the UAE since 2020, with a focus on
                            excellence and exceptional service.
                        </p>
                    </div>

                    {/* Columna 2 - Contact */}
                    <div className="space-y-4">
                        <h3 className="text-xl font-bold text-blue-900">Contact Info</h3>
                        <div className="space-y-2">
                            <div className="flex items-center space-x-2">
                                <Phone className="w-5 h-5 text-blue-600"/>
                                <span className="text-gray-600">+971 052 788 9164</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <Mail className="w-5 h-5 text-blue-600"/>
                                <span className="text-gray-600 break-all">info@businesssolutionsdubai.com</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <MapPin className="w-5 h-5 text-blue-600"/>
                                <span className="text-gray-600">Dubai, United Arab Emirates</span>
                            </div>
                        </div>
                    </div>

                    {/* Columna 3 - Quick Links */}
                    <div className="space-y-4">
                        <h3 className="text-xl font-bold text-blue-900">Quick Links</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="/services" className="text-gray-600 hover:text-blue-600 transition-colors">
                                    Services
                                </a>
                            </li>
                            <li>
                                <a href="/dubai-work-zones"
                                   className="text-gray-600 hover:text-blue-600 transition-colors">
                                    Freezones
                                </a>
                            </li>
                            <li>
                                <a href="/pricing" className="text-gray-600 hover:text-blue-600 transition-colors">
                                    Pricing
                                </a>
                            </li>
                            <li>
                                <a href="/zones-info-dubai"
                                   className="text-gray-600 hover:text-blue-600 transition-colors">
                                    Companies
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Columna 4 - Social Media */}
                    <div className="space-y-4">
                        <h3 className="text-xl font-bold text-blue-900">Follow Us</h3>
                        <div className="flex space-x-4">
                            <a
                                href="https://www.instagram.com/businesssolutionsdubai/"
                                className="p-2 bg-blue-100 rounded-full hover:bg-blue-200 transition-colors"
                                aria-label="Visit our Instagram profile"
                            >
                                <Instagram className="w-6 h-6 text-blue-600"/>
                            </a>
                            <a
                                href="https://www.facebook.com/businesssolutionsdubai/"
                                className="p-2 bg-blue-100 rounded-full hover:bg-blue-200 transition-colors"
                                aria-label="Visit our Facebook page"
                            >
                                <Facebook className="w-6 h-6 text-blue-600"/>
                            </a>
                            <a
                                href="https://www.twitter.com/businesssolutionsdubai/"
                                className="p-2 bg-blue-100 rounded-full hover:bg-blue-200 transition-colors"
                                aria-label="Visit our Twitter profile"
                            >
                                <Twitter className="w-6 h-6 text-blue-600"/>
                            </a>
                            <a
                                href="https://www.linkedin.com/company/business-solutions-dubai/"
                                className="p-2 bg-blue-100 rounded-full hover:bg-blue-200 transition-colors"
                                aria-label="Visit our LinkedIn company page"
                            >
                                <MessageCircle className="w-6 h-6 text-blue-600"/>
                            </a>
                        </div>
                    </div>

                </div>

                {/* Separador */}
                <div className="border-t border-gray-200 pt-8">
                    {/* Logo y Copyright */}
                    <div className="flex flex-col md:flex-row items-center justify-between">
                        <div className="flex items-center mb-4 md:mb-0">
                            <div className="w-16 h-16 flex items-center justify-center">
                                <img src={logo} alt="logo-footer-business-dubai" className="w-24"/>
                            </div>
                        </div>
                        <div className="text-center md:text-right">
                            <p className="text-gray-600">
                                © 2024 Business Solutions Dubai. All rights reserved.
                            </p>
                            <p className="text-gray-600 my-16">
                                Developed by{" "}
                                <a
                                    href="https://portfolio-virid-mu-25.vercel.app/"
                                    className="text-blue-600 hover:text-blue-800 font-medium"
                                >
                                    Fabian Tinjaca
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;